import { Card, CardContent, Grid, Typography } from "@mui/material";

const getStatusStyle = (bgColor) => ({
  backgroundColor: bgColor,
  color: "#ffffff",
  fontWeight: "bold",
  borderRadius: "20px",
  padding: "4px 12px",
  minWidth: "40px",
  textAlign: "center",
});

const TransactionCard = ({ data, onClick }) => {
  return (
    <Card
      onClick={onClick}
      elevation={3}
      sx={{
        borderRadius: "10px",
        padding: "8px",
        cursor: "pointer",
        "&:hover": {
          opacity: 0.6,
        },
      }}
    >
      <CardContent sx={{ paddingBottom:"16px !important" }}>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={1.5}
        >
          <Grid item xs={6}>
            <Typography component="p">{data?.TransactionTypeName}</Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography
              variant="body1"
              sx={getStatusStyle("#4caf50")} // Green background
            >
              {data?.SuccessCount}
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography
              variant="body1"
              sx={getStatusStyle("#f44336")} // Red background
            >
              {data?.FailedCount}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default TransactionCard;
